// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loading_loading-container__czPLU {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.Loading_loading-container__czPLU svg {
  font-family: Arial, sans-serif;
  font-size: 40px;
  font-weight: bold;
  fill: #00b4f3;
}
.Loading_loading-container__letter__8Vkkx {
  opacity: 0;
  animation: Loading_fadeIn__Ri\\+ah 1s ease-in-out infinite alternate;
}
@keyframes Loading_fadeIn__Ri\\+ah {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Loading/Loading.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AACF;AACE;EACE,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AACJ;AAEE;EACE,UAAA;EAEA,mEAAA;AAAJ;AAYE;EACE;IACE,UAAA;EAFJ;EAIE;IACE,UAAA;EAFJ;AACF","sourcesContent":[".loading-container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 9999;\n\n  svg {\n    font-family: Arial, sans-serif;\n    font-size: 40px;\n    font-weight: bold;\n    fill: #00b4f3;\n  }\n\n  &__letter {\n    opacity: 0;\n    -webkit-animation: fadeIn 1s ease-in-out infinite alternate;\n    animation: fadeIn 1s ease-in-out infinite alternate;\n  }\n\n  @-webkit-keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-container": `Loading_loading-container__czPLU`,
	"loading-container__letter": `Loading_loading-container__letter__8Vkkx`,
	"fadeIn": `Loading_fadeIn__Ri+ah`
};
export default ___CSS_LOADER_EXPORT___;
